import { render, staticRenderFns } from "./SolutionsSection.vue?vue&type=template&id=57bfeaae&scoped=true"
import script from "./SolutionsSection.vue?vue&type=script&lang=js"
export * from "./SolutionsSection.vue?vue&type=script&lang=js"
import style0 from "./SolutionsSection.vue?vue&type=style&index=0&id=57bfeaae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bfeaae",
  null
  
)

export default component.exports